/* eslint-disable
    default-case
    */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import reactUpdate from 'immutability-helper';
import _ from 'underscore';

import {assert} from 'Asserts';
import {StandardDNACodon} from 'biojs/Codons';
import {Sequence as BioJSSequence} from 'biojs/Sequence';
import {Sequence} from 'components/Sequence';
import {HRTemplateStep} from 'constants/CRISPRConstants';
import {EventConstants} from 'constants/EventConstants';
import {SequenceVersion} from 'constants/SequenceConstants';
import AppDispatcher, {FluxAction} from 'lib/Dispatcher';
import Store from 'lib/Store';
import OrganismActions from 'molbio/genome/organism/OrganismActions';
import GenomeStore from 'stores/GenomeStore';

interface HRTemplateDesign {
  sequence: Sequence;
  modifyingSequence: boolean;
  resettingToVersion: boolean;
  _mutatedSequence: null | unknown;
  columns: null | Array<HRTemplateColumn>;
  targetSite: null | TargetSite;
  warningMessage: null | string;
  errorMessage: null | string;
}

export interface HRTemplateColumn {
  start: number;
  end: number;
  isCoding: boolean;
  mutated?: StandardDNACodon;
}

export interface TargetSite {
  stale?: boolean;
  strand: number;
  start: number;
  end: number;
}

export interface HRTemplateDesignState {
  step: string;
  sequence: null | Sequence;
  originalBases: string;
  savedVersions: {[step in HRTemplateStep]: SequenceVersion & {bases: string}};
  armRegion: {
    start: number;
    end: number;
  };
  resettingToVersion: boolean;
  modifyingSequence: boolean;
  isHRTemplateLoading: boolean;
  hrTemplateLoadingXHRCount: number;
  pam: string;
  guide: string;
  genome: Genome;
  warningMessage?: string;
  errorMessage?: string;
  targetSite?: TargetSite;
  columns?: Array<HRTemplateColumn>;
  codonUsage?: Record<StandardDNACodon, number>;
  _mutatedSequence: BioJSSequence;
  organismId: number;
}

interface Organism {
  id: number;
}

interface Genome {
  ensemblName: string;
  organism: Organism | null;
}

interface PendingSelection {
  start: number;
  end: number;
}

class HRTemplateStore extends Store {
  sequenceIdToDesign!: {[sequenceId: string]: null | HRTemplateDesignState};
  sequenceIdToPendingSelection!: {[sequenceId: string]: PendingSelection};

  defaultDesign(data: Partial<HRTemplateDesign>): HRTemplateDesign {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(
      {
        modifyingSequence: false,
        resettingToVersion: false,
        _mutatedSequence: null,
        columns: null,
        targetSite: null,
        warningMessage: null,
        errorMessage: null,
      },
      data
    );
  }

  override resetState(): void {
    this.sequenceIdToDesign = {};
    this.sequenceIdToPendingSelection = {};
  }

  containsDesign(sequenceId: string): boolean {
    return (
      (this.sequenceIdToDesign[sequenceId] != null
        ? this.sequenceIdToDesign[sequenceId].sequence
        : undefined) != null
    );
  }

  getDesignState(sequenceId: string): HRTemplateDesignState | null {
    let designState = this.sequenceIdToDesign[sequenceId];
    if (designState != null) {
      designState = reactUpdate(designState, {
        $merge: {isHRTemplateLoading: designState.hrTemplateLoadingXHRCount > 0},
      });
      // eslint-disable-next-line no-restricted-syntax
      designState = _.omit(designState, 'hrTemplateLoadingXHRCount');
    }
    return designState;
  }

  getPendingSelection(sequenceId: string): PendingSelection {
    return this.sequenceIdToPendingSelection[sequenceId];
  }

  _update(
    sequenceId: string,
    dataToMerge: Partial<{genome: null | Genome; organismId: number} & HRTemplateDesign>
  ): void {
    // eslint-disable-next-line benchlint/no-in-operator
    if (sequenceId in this.sequenceIdToDesign) {
      this.sequenceIdToDesign = reactUpdate(
        this.sequenceIdToDesign,
        _.object([[sequenceId, {$merge: dataToMerge}]])
      );
    } else {
      this.sequenceIdToDesign = reactUpdate(
        this.sequenceIdToDesign,
        _.object([[sequenceId, {$set: dataToMerge}]])
      );
    }

    if (dataToMerge.genome != null) {
      const genome = _.findWhere(GenomeStore.getGenomes(), {ensemblName: dataToMerge.genome.ensemblName});
      if (genome!.organism != null) {
        OrganismActions.getCodonUsage(genome!.organism.id);
        this._update(sequenceId, {
          organismId: genome!.organism.id,
        });
      }
    }
  }

  _updatePendingSelection(sequenceId: string, pendingSelection: Partial<PendingSelection>): void {
    this.sequenceIdToPendingSelection = reactUpdate(
      this.sequenceIdToPendingSelection,
      _.object([[sequenceId, {$set: pendingSelection}]])
    );
  }

  incrementXHRCount(sequenceId: string): void {
    const incrementFunc = (counter: number): number => counter + 1;
    // eslint-disable-next-line benchlint/no-in-operator
    if (!(sequenceId in this.sequenceIdToDesign)) {
      this.sequenceIdToDesign = reactUpdate(
        this.sequenceIdToDesign,
        _.object([[sequenceId, {$set: {hrTemplateLoadingXHRCount: 0}}]])
      );
    }
    this.sequenceIdToDesign = reactUpdate(
      this.sequenceIdToDesign,
      _.object([[sequenceId, {hrTemplateLoadingXHRCount: {$apply: incrementFunc}}]])
    );
  }

  decrementXHRCount(sequenceId: string): void {
    // eslint-disable-next-line benchlint/no-in-operator
    assert(sequenceId in this.sequenceIdToDesign, 'Expected sequence to exist');
    const decrementFunc = (counter: number): number => counter - 1;
    this.sequenceIdToDesign = reactUpdate(
      this.sequenceIdToDesign,
      _.object([[sequenceId, {hrTemplateLoadingXHRCount: {$apply: decrementFunc}}]])
    );
  }

  override payloadHandler(action: FluxAction): boolean {
    switch (action.actionType) {
      case EventConstants.HR_TEMPLATE_CREATE:
      case EventConstants.HR_TEMPLATE_UPDATE:
      case EventConstants.HR_TEMPLATE_FETCH_FOR_SEQUENCE:
        this.incrementXHRCount(action.sequenceId);
        this.emitChange();
        break;

      case EventConstants.HR_TEMPLATE_CREATE_COMPLETED:
      case EventConstants.HR_TEMPLATE_FETCH_FOR_SEQUENCE_COMPLETED: {
        const data = this.defaultDesign(action.data);
        this._update(action.sequenceId, data);

        this.decrementXHRCount(action.sequenceId);
        this.emitChange();
        break;
      }

      case EventConstants.HR_TEMPLATE_UPDATE_COMPLETED:
        this._update(action.sequenceId, action.data);
        this.decrementXHRCount(action.sequenceId);
        this.emitChange();
        break;

      case EventConstants.HR_TEMPLATE_UPDATE_PENDING_SELECTION:
        this._updatePendingSelection(action.sequenceId, action.pendingSelection);
        this.emitChange();
        break;

      case EventConstants.HR_TEMPLATE_CREATE_FAILED:
      case EventConstants.HR_TEMPLATE_UPDATE_FAILED:
      case EventConstants.HR_TEMPLATE_FETCH_FOR_SEQUENCE_FAILED:
        this.decrementXHRCount(action.sequenceId);
        this.emitChange();
        break;
    }
    return true;
  }
}

export default new HRTemplateStore(AppDispatcher);
